import { 
  SLIDE_ONE_DRAG_DROP, 
  SLIDE_ONE_REMOVE_DROP, 
  SLIDE_ONE_SET_AS_NEXT_STEP 
} from "../../Redux.constants";
import { 
  slideOneSetAsNextStep, 
  slideOneDragDrop, 
  slideOneRemoveDrop 
} from "./helper";

export function SlideOneReducer(state={}, action) {
  switch (action.type) {
    case SLIDE_ONE_DRAG_DROP:
      return slideOneDragDrop(state, action.payload);
    case SLIDE_ONE_REMOVE_DROP:
      return slideOneRemoveDrop(state, action.payload);
    case SLIDE_ONE_SET_AS_NEXT_STEP:
      return slideOneSetAsNextStep(state, action.payload);
    default:
      return state;
  }
}